import styled from 'styled-components/macro';

const PlayAgainButton = styled.button`
  background: hsl(0, 0%, 100%);
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-weight: bold;
  height: 6rem;
  letter-spacing: 0.3rem;
`;

export default PlayAgainButton;
